import * as React from 'react';
import { Redirect } from 'react-router-dom';

const Home = () => (
  <Redirect to="/accounts/summary" />
);

export default Home;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/home/Home.tsx